import React from 'react';
import Moment from 'react-moment';
import cn from 'classnames';
import { number, node, string, bool } from 'prop-types';
import SVG from 'react-inlinesvg';
import { STATIC_PATH } from '../../config';

const propTypes = {
  timestamp: number.isRequired,
  tag: node,
  className: string,
  withIconTime: bool,
  withIconDateTime: bool,
};

const defaultProps = {
  tag: 'span',
};

const DateTime = ({
  timestamp,
  tag: Tag,
  className,
  theme,
  withIconTime,
  withDateTime,
  withIconDateTime,
  ...rest
}) => {
  return (
    <Tag className={cn('datetime', className)} {...rest}>
      {!withIconTime && !withIconDateTime && !withDateTime && (
        <>
          <Moment format="DD.MM.YYYY" unix>
            {timestamp}
          </Moment>
          <span className="font-weight-bolder datetime-dot"> · </span>
          <Moment element="ins" format="LT" unix>
            {timestamp}
          </Moment>
        </>
      )}
      {withDateTime && (
        <>
          <Moment element="ins" format="DD.MM.YYYY" unix>
            {timestamp}
          </Moment>
          &nbsp;<span className="font-weight-bolder"> · </span>
          <Moment element="ins" className={theme === 4 ? '' : 'gray'} format="LT" unix>
            {timestamp}
          </Moment>
        </>
      )}
      {withIconDateTime && (
        <>
          <SVG
            className="datetime-circle"
            src={`${STATIC_PATH}/img/action-icons/time_circle.svg`}
            height="16"
            width="16"
            cacheRequests
          />
          &nbsp;&nbsp;
          <Moment element="ins" format="DD.MM.YYYY" unix>
            {timestamp}
          </Moment>
          &nbsp;<span className="font-weight-bolder"> · </span>
          <Moment element="ins" className="gray" format="LT" unix>
            {timestamp}
          </Moment>
        </>
      )}
      {withIconTime && (
        <>
          <SVG
            className="datetime-circle"
            src={`${STATIC_PATH}/img/action-icons/time_circle.svg`}
            height="16"
            width="16"
            cacheRequests
          />
          &nbsp;&nbsp;<span className="font-weight-bolder"> · </span>
          <Moment element="ins" format="LT" unix>
            {timestamp}
          </Moment>
        </>
      )}
    </Tag>
  );
};

DateTime.propTypes = propTypes;
DateTime.defaultProps = defaultProps;

export default DateTime;
